import Icon from "@mui/icons-material/AccountBalance";
import SabilLedgerShow from "./SabilLedgerShow";

export default {
  show: SabilLedgerShow,
  icon: Icon,
  label: "Sabil Ledger",
  options: { label: "Sabil Ledger" },
  name: "sabilLedger",
};
